import React from "react";
import "./MegaLotoInfo.css";

const MegaLotoInfo = () => {
  const click = ()=>{
    window.location.href = 'https://w.app/MegalotoTrimmerBuda';
   }
  return(
    <section className="megaloto-info">
      <h2>¿Por qué confiar en MegaLoto?</h2>
      <p>
        MegaLoto es una plataforma líder en sorteos y juegos en línea, comprometida con la transparencia y la diversión. 
      </p>
      <ul>
        <li>🔒 Seguridad en todas las transacciones.</li>
        <li>🎉 Sorteos garantizados y resultados públicos.</li>
        <li>🌟 Más de 100 usuarios satisfechos.</li>
      </ul>
      <button className="cta-button" onClick={click}>
        Visita MegaLoto Ahora
      </button>
    </section>
  )
};

export default MegaLotoInfo;
